// Central logger: verbose in development, silent in production builds (no debug data exposed to users).
const isDev = process.env.NODE_ENV !== "production";

/* eslint-disable no-console */
export const logError = (message, error) => {
  if (isDev) console.error(`[Douceur] ${message}`, error);
};

export const logWarn = (message, detail) => {
  if (isDev) console.warn(`[Douceur] ${message}`, detail);
};
/* eslint-enable no-console */
